var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import '@styles/webdesktop/stylesheets/contextMenuItem.scss';
import { SvgIconType } from '../../SvgIcon/SvgIconType';
import React, { forwardRef } from 'react';
import { SvgIcon } from '../../SvgIcon/SvgIcon';
import { Typography } from '../../Typography/Typography';
import { TypographyLevel } from '../../Typography/TypographyLevel';
import { Size } from '@front/sharedcomponents/Variables';
import { Style, StyleContext, StyleState } from '../../../Style';
export const ContextMenuItem = forwardRef((_a, ref) => {
    var { text, hasLeftOffset = false, hasRightOffset = false, hasSubitems = false, size = Size.Medium, icon = null, disabled = false, disabledReason = null, checked = false, isBeta = false, onClick, onPointerEnter } = _a, restItemProps = __rest(_a, ["text", "hasLeftOffset", "hasRightOffset", "hasSubitems", "size", "icon", "disabled", "disabledReason", "checked", "isBeta", "onClick", "onPointerEnter"]);
    const renderIcon = () => {
        if (!hasLeftOffset) {
            return null;
        }
        let iconType = null;
        if (checked) {
            iconType = SvgIconType.Checkbox;
        }
        else if (disabled && isValidString(disabledReason)) {
            iconType = SvgIconType.MenuError;
        }
        else {
            iconType = icon;
        }
        return (React.createElement("div", { className: "context-menu-item-icon" },
            React.createElement(SvgIcon, { icon: iconType })));
    };
    const renderText = () => {
        return (React.createElement("div", { className: "context-menu-item-text" },
            React.createElement(Typography, { level: TypographyLevel.BodyMd, noWrap: true }, text)));
    };
    const renderSubitems = () => {
        if (!hasRightOffset) {
            return null;
        }
        return (React.createElement("div", { className: "context-menu-item-subitems" }, hasSubitems && React.createElement(SvgIcon, { icon: SvgIconType.ArrowRight })));
    };
    const handlePointerEnter = (event) => {
        if (disabled) {
            return;
        }
        onPointerEnter === null || onPointerEnter === void 0 ? void 0 : onPointerEnter(event.currentTarget);
    };
    const handleClick = () => {
        if (disabled) {
            return;
        }
        onClick === null || onClick === void 0 ? void 0 : onClick();
    };
    const handleKeyDown = (e) => {
        if (disabled) {
            return;
        }
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleClick();
        }
    };
    const classNames = [
        'context-menu-item',
        size,
        Style.Secondary,
        StyleContext.ListItem,
        disabled ? StyleState.Disabled : ''
    ];
    const className = classNames.filter(Boolean).join(' ');
    return (React.createElement("li", Object.assign({ ref: ref, role: "menuitem" /* NOSONAR S6842 - li as menuitem with role is intentional */, className: className, tabIndex: disabled ? -1 : 0, onClick: handleClick, onKeyDown: handleKeyDown, onPointerEnter: handlePointerEnter, "aria-disabled": disabled }, restItemProps),
        renderIcon(),
        renderText(),
        renderSubitems(),
        isBeta && React.createElement(SvgIcon, { icon: SvgIconType.Beta, size: Size.None })));
});
